import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useState } from "react";
import { FollowButtonDisplay, FollowType } from "scmp-sdk";

import { accountAtom } from "shared/lib/account";

import { MyNewsInitFollowPackagesItem } from "scmp-app/components/my-news/init-follow-packages/item";
import { MynewsText } from "scmp-app/components/my-news/mynews-text";
import type { TopicPackage } from "scmp-app/pages/mynews/types";

import {
  ButtonWrapper,
  Container,
  ItemsWrapper,
  LoginLink,
  LoginReminder,
  LoginReminderWrapper,
  StyledFollowButton,
  Title,
  TitleHighlight,
  TitleWrapper,
} from "./styles";

type Props = {
  topicPackages: TopicPackage[];
};

export const MyNewsInitFollowPackages: FunctionComponent<Props> = ({ topicPackages }) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { isLoggedIn } = useAtomValue(accountAtom);

  const handleItemClick = (packageCode: string, isSelected: boolean) => {
    setSelectedItems(previousItems =>
      isSelected
        ? [...previousItems, packageCode]
        : previousItems.filter(item => item !== packageCode),
    );
  };

  const isSelectedTopicPackages = selectedItems.length > 0;

  return (
    <Container>
      <TitleWrapper>
        <TitleHighlight>Select one or more packages...</TitleHighlight>
        <Title>that interest you</Title>
      </TitleWrapper>
      {!isLoggedIn && (
        <LoginReminderWrapper>
          <LoginReminder>
            If you have set-up <MynewsText /> on the SCMP app, <LoginLink>log in</LoginLink> now.
          </LoginReminder>
        </LoginReminderWrapper>
      )}
      <ItemsWrapper>
        {topicPackages.map(topicPackage => (
          <MyNewsInitFollowPackagesItem
            key={topicPackage.packageName}
            onClick={handleItemClick}
            packageName={topicPackage.packageName}
          />
        ))}
      </ItemsWrapper>
      <ButtonWrapper>
        <StyledFollowButton
          $isEnabled={isSelectedTopicPackages}
          display={FollowButtonDisplay.MyNewsSetup}
          entityIds={topicPackages
            .filter(topicPackage => selectedItems.includes(topicPackage.packageName))
            .flatMap(topicPackage => topicPackage.topicIds)}
          name="myNewsSetup"
          source="Topic"
          type={FollowType.Topic}
        />
      </ButtonWrapper>
    </Container>
  );
};

MyNewsInitFollowPackages.displayName = "MyNewsInitFollowPackages";
